import { useEffect, useState, useMemo } from 'react';
import { getUserState, isUserPermitted, httpGet } from '../utils';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';

export function useChatbotAuthStatus() {
    const [userData, setUserData] = useState({});
    const [isAuthorizedToUse, setIsAuthorizedToUse] = useState(undefined);

    useEffect(() => {
        async function loadUserData() {
            try {
                const userData = await getUserState();
                setUserData(userData);
            } catch (err) {
                console.error(err);
            }
        }
        async function loadIsAuthorized() {
            try {
                const {
                    data: { authorized }
                } = await httpGet(`/chats/getIsAiUsageAuthorized`);
                setIsAuthorizedToUse(authorized);
            } catch (err) {
                console.error(err);
            }
        }

        loadUserData();
        loadIsAuthorized();
    }, []);

    const isPermittedToApproveUsage = useMemo(
        () => isUserPermitted(userData.user, 'settings', ROLES.EDITOR.value),
        [userData.user]
    );

    return { isAuthorizedToUse, setIsAuthorizedToUse, isPermittedToApproveUsage };
}
